const Vue = require('vue');
const moment = require('moment');
const $ = require('jquery');

function generateTimeSeries (step) {
    let dt = moment(new Date(1970, 0, 1, 0, 0, 0, 0));
    let rc = [];

    while (dt.date() === 1) {
        const formatted = dt.format('HH:mm')
        const full = dt.format('HH:mm:00')
        rc.push({
            full,
            label: formatted,
            value: formatted,
            clean: formatted.replace(/[^0-9]/g, '')
        });

        dt.add(step, 'minutes')
    }

    return rc;
}

const every10m = generateTimeSeries(10)
const every15m = generateTimeSeries(15)
const every30m = generateTimeSeries(30)

Vue.component('form-datetime', {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        time: {
            type: Boolean,
            default: true
        },
        date: {
            type: Boolean,
            default: true
        },
        sideBySide: {
            type: Boolean,
            default: true
        },
        default: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        startTimeAt: {
            type: String,
            default: '00:00:00'
        },
        fromToday: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        model (newValue, oldValue) {
            this.updateValueFromModel()
        },
        currentMoment (newValue, oldValue) {
            if (newValue) {
                if (this.date && this.time) {
                    this.model = newValue.utc().format('YYYY-MM-DD HH:mm:00')
                } else if (this.date && !this.time) {
                    this.model = newValue.utc().format('YYYY-MM-DD')
                } else if (!this.date && this.time) {
                    this.model = newValue.format('HH:mm:00')
                }
            } else {
                this.model = null
            }

            this.updateValue()
        },
        currentTime (newValue, oldValue) {
            if (newValue) {
                if (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(newValue)) {
                    this.invalidTime = false

                    this.updateValueFromTime()
                } else {
                    this.invalidTime = true
                }
            }

            this.focusCurrentTime()
        }
    },
    methods: {
        updateValue () {
            if (this.date) {
                const $dtp = $(this.$els.input)

                const dtp = $dtp.data('DateTimePicker')

                if (dtp) {
                    if (this.currentDate) {
                        dtp.date(this.currentDate.replace(/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/g, '$3/$2/$1'))
                    } else {
                        dtp.date(null)
                    }
                }
            }
        },
        updateValueFromDate () {
            if (this.time && this.currentDate && this.currentTime) {
                this.currentMoment = moment(`${this.currentDate} ${this.currentTime}`, 'YYYY-MM-DD HH:mm')
            } else if (this.currentDate) {
                this.currentMoment = moment.utc(`${this.currentDate}`, 'YYYY-MM-DD')
            }
        },
        updateValueFromMoment () {
            if (this.currentMoment) {
                const local = this.currentMoment.clone()

                this.currentDate = local.format('YYYY-MM-DD')
                this.currentTime = local.format('HH:mm')
            } else if (!this.date && this.time) {
                this.currentDate = '1990-02-13'
                this.currentTime = null
            } else {
                this.currentDate = null
                this.currentTime = null
            }

            this.updateValue()
        },
        updateValueFromModel () {
            if (this.model && this.date && this.time) {
                this.currentMoment = moment.utc(this.model, 'YYYY-MM-DD HH:mm:ss').local()
            } else if (this.model && this.date && !this.time) {
                this.currentMoment = moment.utc(this.model, 'YYYY-MM-DD')
            } else if (this.model && !this.date && this.time) {
                this.currentMoment = moment(`1990-02-13 ${this.model}`, `YYYY-MM-DD HH:mm:ss`)
            } else {
                this.currentMoment = null
            }

            this.updateValueFromMoment()
        },
        updateValueFromTime () {
            if (this.time) {
                this.currentMoment = moment(`${this.currentDate || '1990-02-13'} ${this.currentTime}`, 'YYYY-MM-DD HH:mm')

                this.updateValueFromMoment()
            }
        },
        clear () {
            this.model = null
        },
        showTimeDropdown () {
            document.addEventListener('mouseup', this.hideTimeDropdown)

            this.timeDropdownVisible = true

            this.$nextTick(() => {
                this.focusCurrentTime()
            })
        },
        hideTimeDropdown (evt) {
            const holder = this.$els.holder

            if (holder && evt.target && holder.contains(evt.target)) {
                return
            }

            document.removeEventListener('mouseup', this.hideTimeDropdown)

            this.timeDropdownVisible = false

            // const holder = this.$els.holder
            //
            // if (holder && evt.relatedTarget && holder.contains(evt.relatedTarget)) {
            //     return
            // }
            //
            // this.timeDropdownVisible = false
        },
        pickTime (time) {
            this.currentTime = time.value

            this.timeDropdownVisible = false
        },
        focusCurrentTime () {
            this.$nextTick(() => {
                const holder = this.$els.scrollArea

                if (this.timeDropdownVisible && holder) {
                    let time = ''

                    if (this.currentTime) {
                        const [hours, minutes] = this.currentTime.split(':').map(p => parseInt(p))
                        const seconds = ((parseInt(hours) * 3600) + (parseInt(minutes) * 60))
                        // 900 seconds = 15 minutes
                        const fixedSeconds = Math.ceil(seconds / 900) * 900
                        const fixedHours = Math.floor(fixedSeconds / (60 * 60));
                        const fixedMinutes = Math.floor((fixedSeconds % (60 * 60)) / 60)
                        const fixedTime = `${fixedHours.toString().padStart(2, '0')}:${fixedMinutes.toString().padStart(2, '0')}`;

                        time = fixedTime.replace(/[^0-9]/g, '')
                    }

                    const target = holder.querySelector(`[data-time^='${time}']`)

                    if (target) {
                        setTimeout(() => {
                            holder.scrollTop = target.offsetTop
                        }, 10)
                    }
                }
            })
        },
        fixTime () {
            if (this.currentTime < this.startTimeAt) {
                this.currentTime = this.startTimeAt.replace(/^([0-9][0-9]):([0-9][0-9]).*/, '$1:$2')
            }
        }
    },
    computed: {
        timeSeries () {
            return this.defaultTimeSeries.filter(i => {
                return i.full >= (this.startTimeAt || '00:00:00')
            })
        },
        iconClass () {
            if (this.time && !this.date) {
                return 'fa-clock-o'
            }

            return 'fa-calendar'
        },
        timePlaceholder () {
            if (this.time && !this.date) {
                return this.placeholder
            }

            return 'Hora';
        },
        timeInputStyle () {
            const style = {
                width: '100%',
                borderRight: 'none'
            }

            if (this.date) {
                style.borderRadius = '0'
            } else {
                style.borderTopRightRadius = '0'
                style.borderBottomRightRadius = '0'
                style.paddingLeft = '30px'
            }

            return style
        },
        timeHolderStyle () {
            const style = {
                width: '100%',
                position: 'relative'
            }

            if (!this.date && this.time) {
                style.maxWidth = '100%'
            } else {
                style.maxWidth = '60px'
            }

            return style
        },
        timeClass () {
            const classes = []
            if (this.invalidTime) {
                classes.push('bg-danger')
            }

            return classes
        }
    },
    data () {
        return {
            fieldName: '',
            outputFormat: null,
            currentMoment: null,
            currentDate: null,
            currentTime: null,
            invalidTime: false,
            defaultTimeSeries: every15m,
            timeDropdownVisible: false
        }
    },
    destroyed () {
        document.removeEventListener('mouseup', this.hideTimeDropdown)
    },
    ready () {
        const self = this

        self.fieldName = self._props.model.raw

        if (!self.placeholder) {
            self.placeholder = self.label
        }

        this.updateValueFromModel()

        const $dtp = $(self.$els.input)

        let outputFormat = null

        if (self.date && self.time) {
            outputFormat = 'YYYY-MM-DD HH:mm:ss'
        } else if (self.date && !self.time) {
            outputFormat = 'YYYY-MM-DD'
        }else if (!self.date && self.time) {
            outputFormat = 'HH:mm:ss'
        }

        this.outputFormat = outputFormat

        const options = {
            showClear: true,
            defaultDate: self.default ? new Date() : null,
            locale: 'pt-BR',
            sideBySide: this.sideBySide,
            useCurrent: true,
            format: 'DD/MM/YYYY'
        }

        if (self.fromToday) {
            options.minDate = moment.utc().format('YYYY-MM-DD')
        }

        $dtp
            .datetimepicker(options)
            .on('dp.change', function (event) {
                if (event.date) {
                    const newDate = event.date.format('YYYY-MM-DD')

                    if (newDate !== this.currentDate) {
                        const now = moment().local()
                        const today = now.format('YYYY-MM-DD')

                        self.currentDate = newDate

                        if (!self.currentTime) {
                            if (newDate !== today) {
                                self.currentTime = '10:00'
                            } else {
                                self.currentTime = now.format('HH:mm')
                            }
                        }

                        self.updateValueFromDate()
                    }
                } else {
                    self.currentDate = null

                    self.updateValueFromDate()
                }

                // if (event.date) {
                //     const newDate = event.date.utc().format(self.outputFormat)
                //
                //     if (newDate !== self.model) {
                //         self.model = newDate
                //     }
                // } else {
                //     self.model = null
                // }
            })

        self.updateValueFromMoment()
    },
    template: require('templates/components/form-datetime.html')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/datetime.js